export const CURRENCIES = [
  ["USD", "US Dollar ($)", "$"],
  ["CAD", "Canadian Dollar ($)", "$"],
  ["EUR", "Euro (€)", "€"],
  ["GBP", "British Pound (£)", "£"],
  ["AUD", "Australian Dollar ($)", "$"],
  ["BAM", "Bosnian Mark (KM)", "KM"],
];

export const PAYMENT_TERMS = [
  "Due on receipt",
  "Net 15",
  "Net 30",
  "Net 45",
  "Net 60",
  "2% 10 Net 30",
  "COD",
];

export const currencySymbol = (code) =>
  CURRENCIES.find((c) => c[0] === code)?.[2] || "$";

export const currencyLabel = (code) =>
  CURRENCIES.find((c) => c[0] === code)?.[1] || code || "US Dollar ($)";

export const fmtMoney = (n, code = "USD") =>
  `${currencySymbol(code)}${(Number(n) || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
